var _circle, _path, _path2, _g, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnerCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.6953,
    r: 25,
    fill: "url(#paint0_linear_209_67259)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0195 27.3774C12.0195 20.0756 17.9388 14.1562 25.2407 14.1562C32.5425 14.1562 38.4618 20.0756 38.4618 27.3774V36.7524H12.0195V27.3774Z",
    fill: "url(#paint1_linear_209_67259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26953 27.8579C6.26953 17.3804 14.7632 8.88672 25.2407 8.88672C35.7182 8.88672 44.2118 17.3804 44.2118 27.8579V41.0598H6.26953V27.8579Z",
    stroke: "#FFF5F5",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_67259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5712 31.2266C31.2601 31.2266 31.0078 31.4788 31.0078 31.79V35.3582H32.1346V31.79C32.1346 31.4788 31.8824 31.2266 31.5712 31.2266Z",
    fill: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8633 35.3582V31.79C17.8633 31.4788 18.1155 31.2266 18.4267 31.2266C18.7378 31.2266 18.9901 31.4788 18.9901 31.79V35.3582",
    fill: "#BC435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5984 26.0288C27.7542 26.0288 26.2539 24.5285 26.2539 22.6843C26.2539 20.8402 27.7542 19.3398 29.5984 19.3398C31.4425 19.3398 32.9429 20.8402 32.9429 22.6843C32.9429 24.5285 31.4425 26.0288 29.5984 26.0288Z",
    fill: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.608 25.6106C19.1096 25.6106 17.8906 24.3915 17.8906 22.8932C17.8906 21.3948 19.1096 20.1758 20.608 20.1758C22.1064 20.1758 23.3254 21.3948 23.3254 22.8932C23.3254 24.3915 22.1064 25.6106 20.608 25.6106Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4375 25.6945C23.9553 26.4464 24.9988 28.0113 24.9988 29.8199L24.2476 35.36H33.6376C33.9488 35.36 34.201 35.1077 34.201 34.7966V29.8199C34.201 28.2235 33.3881 26.8171 32.1536 25.9919C31.4464 26.54 30.5593 26.8665 29.5975 26.8665C28.2436 26.8665 27.038 26.2196 26.2735 25.2188H22.8884C22.755 25.3926 22.6037 25.5521 22.4375 25.6945Z",
    fill: "url(#paint2_linear_209_67259)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3506 25.6953C18.9305 26.103 19.6368 26.3426 20.398 26.3426C21.1592 26.3426 21.8655 26.103 22.4454 25.6953C23.9591 26.4487 24.9991 28.0113 24.9991 29.8169V35.357H16.3603C16.0491 35.357 15.7969 35.1048 15.7969 34.7936V29.8169C15.7969 28.0113 16.8369 26.4487 18.3506 25.6953Z",
    fill: "url(#paint3_linear_209_67259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7969 27.9401C31.7969 27.0598 32.513 26.3438 33.3932 26.3438C34.0663 26.3438 34.6139 26.8914 34.6139 27.5645V28.973C34.6139 29.2841 34.3616 29.5364 34.0505 29.5364H33.3932C32.513 29.5364 31.7969 28.8203 31.7969 27.9401Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6035 29.5364H15.9462C15.6351 29.5364 15.3828 29.2841 15.3828 28.973V27.5645C15.3828 26.8914 15.9304 26.3438 16.6035 26.3438C17.4837 26.3438 18.1998 27.0598 18.1998 27.9401C18.1998 28.8203 17.4837 29.5364 16.6035 29.5364Z",
    fill: "#D6A2BE"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9029,
    cy: 15.5983,
    r: 0.961538,
    fill: "#F16480"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.61388,
    cy: 16.5592,
    r: 0.961538,
    fill: "#D6A2BE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_67259",
    x1: 25,
    y1: 0.695312,
    x2: 25,
    y2: 46.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_67259",
    x1: 25.2407,
    y1: 14.1562,
    x2: 25.2407,
    y2: 36.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_67259",
    x1: 27.2993,
    y1: 25.2188,
    x2: 27.2993,
    y2: 35.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6A2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_67259",
    x1: 20.398,
    y1: 25.6953,
    x2: 20.398,
    y2: 35.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67D95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_67259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2308,
    height: 19.2308,
    fill: "white",
    transform: "translate(15.3828 17.668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerCircles);
export default __webpack_public_path__ + "static/media/inner-circles.9114ae34d7f906345aeb798d3658c7a4.svg";
export { ForwardRef as ReactComponent };